// extracted by mini-css-extract-plugin
export default {"ContactUs_app":"contact_ContactUs_app__OfunZ","ContactUs_content":"contact_ContactUs_content__k9usk","Contact_icon":"contact_Contact_icon__daFmR"};